/** After login/register · `/dashboard` role-splits (admin overview / bidder favorites). */
export const POST_LOGIN_HREF = "/dashboard";

export {
  canAccessBoostFeatures,
  canAccessDealerInquiryCrm,
  canUseFreeListingQuota,
  isAdminUser,
  isDealershipAccount,
  isOwnerUser,
} from "@shared/account-access";

import { isAdminUser, isDealershipAccount, isOwnerUser } from "@shared/account-access";

/** Header / dashboard entry: admins land on نظرة عامة. */
export function dashboardEntryHref(
  user: { role?: unknown; isOwner?: unknown; email?: unknown } | null | undefined,
): string {
  return isAdminUser(user) ? "/dashboard/admin" : "/dashboard/bidder";
}

/** Site super-admin (full archive access). */
export function isSuperAdminUser(user: { role?: unknown; isOwner?: unknown } | null | undefined): boolean {
  return isAdminUser(user) || isOwnerUser(user);
}

/** Matches server `isDealershipListingAllowed` + AddCar gate for dealership users. */
export function canDealershipListCars(
  user:
    | {
        accountType?: unknown;
        dealershipVerificationStatus?: unknown;
      }
    | null
    | undefined,
): boolean {
  if (!isDealershipAccount(user)) return false;
  const status = String(user?.dealershipVerificationStatus ?? "").toLowerCase();
  if (!status) return true;
  return status === "approved";
}

export function canViewSoldArchive(user: { role?: unknown } | null | undefined): boolean {
  return isSuperAdminUser(user);
}

export function canViewDeletedArchive(
  user: { role?: unknown; accountType?: unknown } | null | undefined
): boolean {
  return isSuperAdminUser(user) || isDealershipAccount(user);
}
